export var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["XS"] = 1] = "XS";
    ScreenSize[ScreenSize["S"] = 2] = "S";
    ScreenSize[ScreenSize["M"] = 3] = "M";
    ScreenSize[ScreenSize["L"] = 4] = "L";
    ScreenSize[ScreenSize["XL"] = 5] = "XL";
    ScreenSize[ScreenSize["XXL"] = 6] = "XXL";
})(ScreenSize || (ScreenSize = {}));
//# sourceMappingURL=screenSize.js.map